var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"no-body":""}},[_c('vs-list',[_c('vs-list-header',{attrs:{"color":_vm.color,"icon":_vm.icon,"icon-pack":"feather","title":_vm.title}})],1),_c('vue-apex-charts',{attrs:{"type":"bar","height":"350","options":_vm.chartData.chartOptions,"series":_vm.chartData.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }